export default "__VITE_ASSET__DmQDIxWc__"